export const CREATE_STAGE = "CREATE_STAGE";
export const DELETE_STAGE_ID = "DELETE_STAGE_ID";

export const SELECT_STAGE_ID = "SELECT_STAGE_ID";
export const SELECT_TOOL_ID = "SELECT_TOOL_ID";
export const SELECT_TOOL_ITEM = "SELECT_TOOL_ITEM";
export const SELECT_DEFINITION_ID = "SELECT_DEFINITION_ID";
export const SELECT_RULE_ID = "SELECT_RULE_ID";
export const UPDATE_PAINTING_STATE = "UPDATE_PAINTING_STATE";
export const UPDATE_PLAYBACK_STATE = "UPDATE_PLAYBACK_STATE";
export const UPDATE_KEYPICKER_STATE = "UPDATE_KEYPICKER_STATE";

export const UPSERT_ACTORS = "UPSERT_ACTORS";
export const DELETE_ACTORS = "DELETE_ACTORS";
export const UPDATE_STAGE_SETTINGS = "UPDATE_STAGE_SETTINGS";

export const UPSERT_CHARACTER = "UPSERT_CHARACTER";
export const DELETE_CHARACTER = "DELETE_CHARACTER";
export const CREATE_CHARACTER_VARIABLE = "CREATE_CHARACTER_VARIABLE";
export const DELETE_CHARACTER_VARIABLE = "DELETE_CHARACTER_VARIABLE";
export const CREATE_CHARACTER_FLOW_CONTAINER = "CREATE_CHARACTER_FLOW_CONTAINER";
export const DELETE_CHARACTER_APPEARANCE = "DELETE_CHARACTER_APPEARANCE";
export const ADJUST_FOR_APPEARANCE_ANCHOR_CHANGE = "ADJUST_FOR_APPEARANCE_ANCHOR_CHANGE";
export const SET_CHARACTER_Z_ORDER = "SET_CHARACTER_Z_ORDER";

export const ADVANCE_GAME_STATE = "ADVANCE_GAME_STATE";
export const INPUT_FOR_GAME_STATE = "INPUT_FOR_GAME_STATE";
export const STEP_BACK_GAME_STATE = "STEP_BACK_GAME_STATE";
export const REWIND_ALL_GAME_STATE = "REWIND_ALL_GAME_STATE";

export const EDIT_RULE_RECORDING = "EDIT_RULE_RECORDING";
export const SETUP_RECORDING_FOR_ACTOR = "SETUP_RECORDING_FOR_ACTOR";
export const SETUP_RECORDING_FOR_CHARACTER = "SETUP_RECORDING_FOR_CHARACTER";
export const SETUP_CHECK_RECORDING_FOR_ACTOR = "SETUP_CHECK_RECORDING_FOR_ACTOR";
export const CANCEL_RECORDING = "CANCEL_RECORDING";
export const FINISH_RECORDING = "FINISH_RECORDING";
export const SET_RECORDING_EXTENT = "SET_RECORDING_EXTENT";
export const START_RECORDING = "START_RECORDING";
export const UPSERT_RECORDING_CONDITION = "UPSERT_RECORDING_CONDITION";
export const UPDATE_RECORDING_ACTIONS = "UPDATE_RECORDING_ACTIONS";
export const TOGGLE_RECORDING_SQUARE_IGNORED = "TOGGLE_RECORDING_SQUARE_IGNORED";

export const UPDATE_MODAL_STATE = "UPDATE_MODAL_STATE";
export const UPDATE_TUTORIAL_STATE = "UPDATE_TUTORIAL_STATE";

export const UPSERT_GLOBAL = "UPSERT_GLOBAL";
export const DELETE_GLOBAL = "DELETE_GLOBAL";
export const UPSERT_STAGE_VARIABLE = "UPSERT_STAGE_VARIABLE";
export const DELETE_STAGE_VARIABLE = "DELETE_STAGE_VARIABLE";
export const SET_STAGE_VARIABLE_VALUE = "SET_STAGE_VARIABLE_VALUE";
export const UPDATE_WORLD_METADATA = "UPDATE_WORLD_METADATA";
